<div class="box relative">
    <app-loader *ngIf="searching" loaderType="cover" overlayColor="white"></app-loader>

    <div class="h-100 relative inner">
        <div class="table-flex table-softer rounded o-hidden" [ngClass]="{ 'table-scroll': scrollbarYEnabled }">
            <div class="thead bg-softer">
                <div class="trow">
                    <div class="tcell small"></div>
                    <div class="tcell grow text-xs font-semi-bold text-muted" translate>v3-byoc-popup-create-episode-course-table-course-name</div>
                    <div class="tcell grow text-xs font-semi-bold text-muted" translate>v3-byoc-popup-create-episode-course-table-created-by</div>
                    <div class="tcell small"></div>
                </div>
            </div>
            <div #ps class="tbody" [perfectScrollbar]="{ suppressScrollX: true, wheelPropagation: false }" (psYReachEnd)="psYReachEnd()">
                <div class="trow" *ngFor="let course of courses" [elementDataTest]="course.id">
                    <div class="tcell center small">
                        <!-- Radio -->
                        <div class="radio radio-success radio-single">
                            <input
                                [id]="'form-radio-table' + course.id"
                                type="radio"
                                [formControl]="courseIdControl"
                                [value]="course.id"
                                name="form-radio-table"
                            />
                            <label [for]="'form-radio-table' + course.id">
                                <span class="icon" [inlineSVG]="'assets/icons.svg#dot'"></span>
                            </label>
                        </div>
                    </div>
                    <div class="tcell grow text-xs font-semi-bold">{{ course.name }}</div>
                    <div class="tcell grow text-xs font-semi-bold">
                        {{ course.original ? ('v3-global-socialtalent' | translate) : course.user?.firstname + ' ' + course.user?.surname }}
                    </div>
                    <div class="tcell center small">
                        <a
                            *ngIf="course.status === 1 || course.stats?.episodes?.total === 0"
                            class="icon icon-l icon-muted"
                            inlineSVG="assets/icons.svg#open-external"
                        ></a>
                        <a
                            *ngIf="course.status === 2 && course.stats?.episodes?.total !== 0"
                            [routerLink]="['/library', 'course', course.id]"
                            [target]="'_blank'"
                            class="icon icon-l icon-default poiner icon-hover-info pointer"
                            inlineSVG="assets/icons.svg#open-external"
                            linkDataTest="courseLink"
                        ></a>
                    </div>
                </div>
                <div *ngIf="noResults" class="py-5 font-semi-bold text-xs text-center" translate>v3-byoc-popup-create-episode-course-table-empty</div>
            </div>
        </div>
    </div>
</div>
